// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Schema_wrapper__JwZcf"};